import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, Chip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "../../../reduxToolkit/features/frontend/checkout";
import { useState } from "react";
import LoadingBox from "../../../components/misc/Loading";
import { getAllCustomers } from "../../../reduxToolkit/features/auth";
import OrderCard from "./OrderCard";
import PageHeader from "../../../components/adminPanel/shared/PageHeader";
import EmptyStateAlert from "../../../components/adminPanel/shared/EmptyStateAlert";
import { colors } from "../../../theme/designTokens";

export default function ManageOrders() {
  const dispatch = useDispatch();

  const [loadingMain, setLoadingMain] = useState(false);
  const [lang, setLang] = useState("");
  const [, setLangId] = useState("");
  const [orderList, setOrderList] = useState([]);

  // LocalData
  const localLangData = JSON.parse(localStorage.getItem("lang"));

  // Store
  const { orders } = useSelector((state) => state.checkout);
  const {
    activeLang
  } = useSelector((state) => state.misc);

  // Use Effect
  useEffect(() => {
    dispatch(getAllOrders());
    dispatch(getAllCustomers());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set Language
  useEffect(() => {
    if (activeLang && activeLang.langCode) {
      setLang(activeLang.langCode);
      setLangId(activeLang._id);
    } else {
      if (localLangData) {
        setLang(localLangData.langCode);
        setLangId(localLangData._id);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);

  useEffect(() => {
    if (orders && orders.length > 0) {
      const O = orders.filter((o) => o.orderNumber);
      if (O) setOrderList(O);
    }
  }, [orders]);

  useEffect(() => {
    setLoadingMain(true);
    setTimeout(() => {
      setLoadingMain(false);
    }, 2000);
  }, []);

  return (
    <>
      <PageHeader
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            Orders
            <Chip
              label={orderList.length}
              size="small"
              sx={{ bgcolor: colors.primary, color: colors.white, fontWeight: 700 }}
            />
          </Box>
        }
      />
      <Grid container spacing={1} alignItems="stretch">
        {loadingMain ? (
          <LoadingBox w={"100%"} />
        ) : orderList.length < 1 ? (
          <Grid item xs={12}>
            <EmptyStateAlert message="No Orders..." />
          </Grid>
        ) : (
          orderList.map((x, i) => (
            <Grid item key={i} xs={12} sm={6} md={6} lg={4}>
              <OrderCard x={x} lang={lang} />
            </Grid>
          ))
        )}
      </Grid>
    </>
  );
}
